/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';
import { TermsUpdateDto } from '../../models/terms-update-dto';

export interface TermsAdminControllerUpdateV1$Params {
  id: string;
      body: TermsUpdateDto
}

export function termsAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: TermsAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<TermsDto>> {
  const rb = new RequestBuilder(rootUrl, termsAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermsDto>;
    })
  );
}

termsAdminControllerUpdateV1.PATH = '/api/v1/terms/admin/{id}';
